import React, { useState, useEffect } from "react";
import axios from "axios";
import OP from "../assets/op.jpg";

const apiUrl = process.env.REACT_APP_API_URL;


const API_BASE_URL = `${apiUrl}/api/v1/offerAndPromotions`;


const Advertisement = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [latestData, setLatestData] = useState(null);

  useEffect(() => {
    const fetchLatest = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/latest`);
        if (response.data) {
          setLatestData(response.data.offerAndPromotionsInfo);
        }
      } catch (err) {
        console.error("Error fetching latest offer & promotion:", err);
      }
    };

    fetchLatest();
  }, []);

  const imageUrl = latestData?.OFFER_AND_PROMOTIONS_S3_BUCKET_URL_FOR_IMAGE;
  const videoUrl = latestData?.OFFER_AND_PROMOTIONS_S3_BUCKET_URL_FOR_VIDEO;

  return (
    <div className="bg-white rounded shadow-sm w-auto">
      <button
        className="btn btn-light d-flex justify-content-between align-items-center w-100 d-block d-md-none p-3"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="fw-bold">Offers & Promotions</span>
        <i className={`fas ${isOpen ? "fa-chevron-up" : "fa-chevron-down"}`} />
      </button>

      <div className={`collapse ${isOpen ? "show" : ""} d-md-block`}>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="Latest Offer & Promotion"
            className="img-fluid rounded w-100"
          />
        ) : videoUrl ? (
          <video
            src={videoUrl}
            controls
            className="img-fluid rounded w-100"
          />
        ) : (
          <p className="text-center p-3">No offers or promotions available</p>
        )}
      </div>
    </div>
  );
};

export default Advertisement;








